export const getTranslation = (
  key: string,
  language: "en" | "fr" | "nl" = "en"
): string => {
  return translations[language]?.[key] || "";
};

const translations: Record<string, Record<string, string>> = {
  en: {
    standnummer: "Booth number",
    name: "Name",
    contactPerson: "Contact person",
    email: "Email",
    images: "Images",
    lastUploaded: "Last uploaded",
    send: "Send",
    followingExhibitors: "Following exhibitors have not yet uploaded their images:",
    mailTemplate: "Mail template",
    sendReminderMail: "Send reminder mail",
    add: "Add",
    addBulk: "Add Bulk",
    editMailTemplate:"edit mail template",
    downloadCsv: "Download CSV",
    click:"Click",
    here:"here",
    toSendReminder: "to send a reminder email",
    numberImagesUploaded:" images have been uploaded.",
    delete: "Delete",
    loading: "Loading...",
    problemsOrQuestions: "Problems or questions?",
    clickHere: "Click here to contact the organisation.",
    size: "Size",
    preview: "Preview",
    techSpecs: "Technical specifications",
    image: "Image",
    download: "download technical specs",
    upload: "Upload",
    tooLate: "Too late to upload",
    extraInfo: "Extra info",
    extraInfoDescription:
      "You can upload files or photos describing how the images must be displayed.",
    infoCta: "upload info",
    cancel: "Cancel",
    save: "Save",
    overwriteButton: "Overwrite",
    overwrite: "You are going to overwrite an existing image.",
    wantToContinue: "Do you want to continue?",
    caution: "Caution!",
    uploadHere: "Click here to select file, or drag file onto this area",
    uploadFor: "Upload image for",
    uploadImage: "Upload this image",
    problemsOrQuestionsContact:
      "Problems or questions? Click here to contact the organisation.",

    checkboxShort:
      "By ticking this box, I agree that the print file I uploaded can be used for printing..",
    checkboxLong:
      "By ticking this box, I agree that the print file I uploaded can be used for printing – even if I received potential warnings about file resolution or incorrect dimensions. I acknowledge that if I received any of these warnings and can not deliver a higher quality print file, Alter Expo can not be held responsible if the perceived quality and/or dimensions of the printed panel/canvas in real-life are not as desired.",
  },
  nl: {
    standnummer: "Standnummer",
    name: "Naam",
    contactPerson: "Contactpersoon",
    email: "Email",
    images: "Afbeeldingen",
    lastUploaded: "Laatst geüpload",
    send: "Verstuur",
    followingExhibitors: "De volgende standhouders hebben nog geen afbeeldingen geüpload:",
    sendReminderMail: "Stuur herinneringsmail",
    mailTemplate: "Mail template",
    add: "Toevoegen",
    addBulk: "Bulk toevoegen",
    editMailTemplate:"mail template bewerken",
    downloadCsv: "Download CSV",
    click:"Klik",
    here:"hier",
    toSendReminder: "om een herinneringsmail te sturen",
    numberImagesUploaded:" afbeeldingen zijn geüpload.",
    delete: "Verwijderen",
    loading: "Bezig met laden...",
    problemsOrQuestions: "Problemen of vragen?",
    clickHere: "Klik hier om de organisatie te contacteren.",
    size: "Afmeting",
    preview: "Preview",
    techSpecs: "Technische specificaties",
    image: "Type",
    download: "download technische specificaties",
    upload: "Upload",
    tooLate: "Te laat om te uploaden",
    extraInfo: "Extra info",
    extraInfoDescription:
      "Je kan bestanden of foto's uploaden die beschrijven hoe de afbeeldingen moeten worden weergegeven.",
    infoCta: "upload info",
    cancel: "Annuleren",
    save: "Opslaan",
    overwrite: "Je gaat een bestaande afbeelding overschrijven.",
   overwriteButton: "Overschrijf",
    wantToContinue: "Wil je doorgaan?",
    caution: "Let op!",
    uploadHere:
      "Klik hier om een bestand te selecteren, of sleep een bestand naar dit gebied",
    uploadFor: "Upload afbeelding voor",
    uploadImage: "Upload deze afbeelding",
    problemsOrQuestionsContact:
      "Problemen of vragen? Klik hier om de organisatie te contacteren.",
    checkboxShort:
      "Door dit vakje aan te vinken, ga ik akkoord dat het printbestand dat ik heb geüpload kan worden gebruikt voor drukwerk.",
    checkboxLong:
      "Door dit vakje aan te vinken, ga ik akkoord dat het printbestand dat ik heb geüpload kan worden gebruikt voor drukwerk – zelfs als ik mogelijke waarschuwingen heb ontvangen over de resolutie van het bestand of onjuiste afmetingen. Ik erken dat als ik een van deze waarschuwingen heb ontvangen en geen printbestand van hogere kwaliteit kan leveren, Alter Expo niet verantwoordelijk kan worden gehouden als de waargenomen kwaliteit en/of afmetingen van het geprinte paneel/doek in het echt niet naar wens zijn.",
    },
  fr: {
    standnummer: "Numéro de stand",
    name: "Nom",
    contactPerson: "Personne de contact",
    email: "Email",
    images: "Images",
    lastUploaded: "Dernier upload",
    send: "Envoyer",
    followingExhibitors: "Les exposants suivants n'ont pas encore téléchargé leurs images :",
    sendReminderMail: "Envoyer un mail de rappel",
    mailTemplate: "Modèle de mail",
    add: "Ajouter",
    addBulk: "Ajouter en masse",
    editMailTemplate:"modifier le modèle de mail",
    downloadCsv: "Télécharger CSV",
    click:"Cliquez",
    here:"ici",
    toSendReminder: "pour envoyer un e-mail de rappel",
    numberImagesUploaded: " images ont été téléchargées.",
    delete: "Supprimer",
    loading: "Chargement...",
    problemsOrQuestions: "Choisissez une taille",

    clickHere: "Cliquez ici pour contacter l'organisation.",
    size: "Dimension",
    preview: "Prévisualisation",
    techSpecs: "Spécifications techniques",
    image: "Image",
    download: "télécharger les spécifications techniques",
    upload: "Télécharger",
    tooLate: "Trop tard pour télécharger",
    extraInfo: "Informations supplémentaires",
    extraInfoDescription:
      "Vous pouvez télécharger des fichiers ou des photos décrivant comment les images doivent être affichées.",
    infoCta: "télécharger des informations",
    cancel: "Annuler",
    save: "Sauvegarder",
    overwrite: "Vous allez écraser une image existante.",
    overwriteButton: "Écraser",
    wantToContinue: "Voulez-vous continuer?",
    caution: "Attention!",
    uploadHere:
      "Cliquez ici pour sélectionner un fichier, ou faites glisser un fichier dans cette zone",
    uploadFor: "Télécharger l'image pour",
    uploadImage: "Télécharger cette image",
    problemsOrQuestionsContact:
      "Des problèmes ou des questions? Cliquez ici pour contacter l'organisation.",
    checkboxShort:
      "En cochant cette case, j'accepte que le fichier d'impression que j'ai téléchargé puisse être utilisé pour l'impression.",
    checkboxLong:
      "En cochant cette case, j'accepte que le fichier d'impression que j'ai téléchargé puisse être utilisé pour l'impression - même si j'ai reçu des avertissements potentiels concernant la résolution du fichier ou des dimensions incorrectes. Je reconnais que si j'ai reçu l'un de ces avertissements et que je ne peux pas fournir un fichier d'impression de meilleure qualité, Alter Expo ne peut être tenu responsable si la qualité perçue et/ou les dimensions du panneau/toile imprimé dans la réalité ne sont pas conformes à mes attentes.",
    },
};
